import React, { useState, useEffect } from 'react';

import { ReactComponent as Email } from '../assets/newHeader/email.svg';
import ellpise from '../assets/public-site/Ellipse_Frame.png';
import { ExportedIcon } from '../components/icons/icons';

type ConnectFormProps = {
  text?: string;
  text2?: string;
  header?: string;
  subHeader?: string;
  buttonText?: string;
  actionButtonText?: string;
};

export const ConnectForm: React.FC<ConnectFormProps> = ({
  text,
  text2,
  header,
  subHeader,
  buttonText,
  actionButtonText,
}) => {
  const [fullName, setFullName] = useState('');
  const [mobile, setMobile] = useState('');
  const [email, setEmail] = useState('');
  const [organization, setOrganization] = useState('');
  const [requirement, setRequirement] = useState('');
  const [isFormValid, setIsFormValid] = useState(false);

  useEffect(() => {
    const isValid = fullName.trim() && mobile.trim() && email.trim() && requirement.trim(); // Organization is optional
    setIsFormValid(Boolean(isValid));
  }, [fullName, mobile, email, requirement]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!isFormValid) return;
    // Handle form submission logic here
    window.open('https://meetings.hubspot.com/chrissybil/vero-learning', '_blank');
    setFullName('');
    setMobile('');
    setEmail('');
    setOrganization('');
    setRequirement('');
    setIsFormValid(false);
  };

  return (
    <section
      className="bg-white py-12 px-4 md:px-8 overflow-hidden bg-no-repeat bg-right-bottom "
      style={{
        backgroundImage: ` 
            url(${ellpise})`,
      }}
    >
      <div className="container grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        <div>
          {subHeader && <p className="text-3xl mb-3">{subHeader}</p>}
          {header && <h2 className="text-5xl md:text-6xl font-medium mb-4">{header}</h2>}
          {text && <p className="text-2xl leading-loose">{text}</p>}
          {text2 && <p className="text-2xl leading-loose">{text2}</p>}
          {actionButtonText && (
            <a
              href="https://meetings.hubspot.com/chrissybil/vero-learning"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-secondary mt-5 !px-6 !py-6 hover:underline !whitespace-normal"
            >
              {actionButtonText} <ExportedIcon />
            </a>
          )}
        </div>

        <div className="bg-primary-500 text-white rounded-[40px] px-9 py-14">
          <h3 className="text-lg font-normal mb-6 flex items-center gap-2">
            <span role="img" aria-label="connect">
              <Email />
            </span>{' '}
            LET’S CONNECT!
          </h3>

          <form className="space-y-6" onSubmit={handleSubmit}>
            <input
              type="text"
              placeholder="Full Name"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              className="w-full bg-transparent px-4 py-4 border-b border-white placeholder:text-white"
            />
            <div className="flex flex-col md:flex-row gap-4">
              <input
                type="text"
                placeholder="Mobile Number"
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
                className="w-full bg-transparent px-4 py-4 border-b border-white placeholder:text-white"
              />
              <input
                type="email"
                placeholder="Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-transparent px-4 py-4 border-b border-white placeholder:text-white"
              />
            </div>
            <textarea
              placeholder="Organization (optional)"
              value={organization}
              onChange={(e) => setOrganization(e.target.value)}
              className="w-full bg-transparent py-4 border-b border-white placeholder:text-white"
            ></textarea>
            <textarea
              placeholder="Let us know your requirement"
              value={requirement}
              onChange={(e) => setRequirement(e.target.value)}
              className="w-full bg-transparent py-4 border-b border-white placeholder:text-white"
            ></textarea>
            <button
              type="submit"
              disabled={!isFormValid}
              className={`btn btn-secondary w-full md:w-auto !px-4 md:!px-14 !bg-white ${
                !isFormValid ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            >
              {buttonText ? buttonText : 'Inquire Now'} <ExportedIcon />
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};
